module.exports = __webpack_public_path__ + "img/dsci0130.2d1bb50e.jpg";